// @ts-nocheck
import { ContactUsTopicsFormFieldValues } from "@store/Framework/Store/Greif/Components/ContactUsTopicsForm/ContactUsTopicsFormState";
import { createHandlerChainRunnerOptionalParameter, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type Parameter = Array<keyof ContactUsTopicsFormFieldValues>;
type HandlerType = Handler<Parameter>;

export const DispatchCancelDraftFieldValues: HandlerType = props => {
    props.dispatch({
        type: "Greif/Components/ContactUsTopicsForm/CancelDraftFieldValues",
        keys: props.parameter,
    });
};

export const chain = [DispatchCancelDraftFieldValues];

const cancelDraftFieldValues = createHandlerChainRunnerOptionalParameter(
    chain,
    [] as Parameter,
    "CancelDraftFieldValues",
);

export default cancelDraftFieldValues;
